import { render, staticRenderFns } from "./MtModal.vue?vue&type=template&id=72eb4c8e&scoped=true&"
import script from "./MtModal.vue?vue&type=script&lang=js&"
export * from "./MtModal.vue?vue&type=script&lang=js&"
import style0 from "./MtModal.vue?vue&type=style&index=0&id=72eb4c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eb4c8e",
  null
  
)

export default component.exports